import type { JSX } from 'react'
export const ComposerEmptyStateIllustration = (): JSX.Element => {
  return (
    <svg
      width="230"
      height="260"
      viewBox="0 0 230 260"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g clipPath="url(#clip0_939_25445)">
        <rect
          x="42.2002"
          y="42.4102"
          width="151.248"
          height="191.138"
          rx="7.18392"
          fill="transparent"
        />
        <rect
          x="42"
          y="87"
          width="151"
          height="147"
          fill="var(--color-illustration-element)"
        />
      </g>
      <rect
        x="42.7002"
        y="42.9102"
        width="150.248"
        height="190.138"
        rx="6.68392"
        stroke="var(--color-illustration-border)"
      />
      <path
        d="M15.14 234.731C14.816 234.829 14.5636 235.084 14.4693 235.409L13.2329 239.67C12.9539 240.632 11.5912 240.632 11.3122 239.67L10.0758 235.409C9.9815 235.084 9.72908 234.829 9.40505 234.731L5.16352 233.447C4.21633 233.161 4.21633 231.82 5.16352 231.533L9.40505 230.25C9.72908 230.152 9.9815 229.896 10.0758 229.571L11.3122 225.31C11.5912 224.348 12.9539 224.348 13.2329 225.31L14.4693 229.571C14.5636 229.896 14.816 230.152 15.14 230.25L19.3816 231.533C20.3288 231.82 20.3288 233.161 19.3816 233.447L15.14 234.731ZM25.9365 240.008C26.2406 240.178 26.6118 240.178 26.9159 240.008L29.2924 238.673C30.1654 238.183 31.1373 239.137 30.6625 240.019L29.323 242.506C29.1636 242.802 29.1636 243.158 29.323 243.454L30.6625 245.941C31.1373 246.823 30.1654 247.778 29.2924 247.287L26.9159 245.953C26.6118 245.782 26.2406 245.782 25.9365 245.953L23.56 247.287C22.687 247.778 21.7151 246.823 22.1899 245.941L23.5293 243.454C23.6888 243.158 23.6888 242.802 23.5293 242.506L22.1899 240.019C21.7151 239.137 22.687 238.183 23.56 238.673L25.9365 240.008ZM12.8391 245.381C13.7173 244.872 14.7067 245.844 14.2144 246.731L13.7435 247.58C13.576 247.882 13.576 248.249 13.7435 248.55L14.2144 249.399C14.7067 250.286 13.7173 251.258 12.8391 250.75L12.0673 250.303C11.7575 250.124 11.3755 250.124 11.0656 250.303L10.2939 250.75C9.41564 251.258 8.42627 250.286 8.91859 249.399L9.38952 248.55C9.55699 248.249 9.55699 247.882 9.38952 247.58L8.9186 246.731C8.42628 245.844 9.41564 244.872 10.2939 245.381L11.0656 245.827C11.3755 246.007 11.7575 246.007 12.0673 245.827L12.8391 245.381Z"
        fill="var(--color-illustration-element)"
      />
      <path
        d="M207.156 30.8304C207.48 30.7323 207.733 30.477 207.827 30.1519L209.063 25.8908C209.342 24.929 210.705 24.929 210.984 25.8908L212.22 30.1519C212.315 30.477 212.567 30.7323 212.891 30.8304L217.133 32.1137C218.08 32.4003 218.08 33.7414 217.133 34.028L212.891 35.3114C212.567 35.4095 212.315 35.6648 212.22 35.9899L210.984 40.2509C210.705 41.2127 209.342 41.2127 209.063 40.2509L207.827 35.9899C207.733 35.6648 207.48 35.4095 207.156 35.3114L202.915 34.028C201.967 33.7414 201.967 32.4003 202.915 32.1137L207.156 30.8304ZM196.36 25.5533C196.055 25.3825 195.684 25.3825 195.38 25.5533L193.004 26.8881C192.131 27.3784 191.159 26.4236 191.634 25.542L192.973 23.055C193.132 22.759 193.132 22.4026 192.973 22.1066L191.634 19.6196C191.159 18.738 192.131 17.7832 193.004 18.2736L195.38 19.6083C195.684 19.7791 196.055 19.7791 196.36 19.6083L198.736 18.2736C199.609 17.7832 200.581 18.738 200.106 19.6196L198.767 22.1066C198.607 22.4026 198.607 22.759 198.767 23.055L200.106 25.542C200.581 26.4236 199.609 27.3784 198.736 26.8881L196.36 25.5533ZM209.457 20.1804C208.579 20.6886 207.589 19.7168 208.082 18.8296L208.553 17.981C208.72 17.6792 208.72 17.3123 208.553 17.0105L208.082 16.1619C207.589 15.2747 208.579 14.303 209.457 14.8112L210.229 15.2578C210.539 15.4371 210.921 15.4371 211.23 15.2578L212.002 14.8112C212.88 14.303 213.87 15.2747 213.378 16.1619L212.907 17.0105C212.739 17.3123 212.739 17.6792 212.907 17.981L213.378 18.8296C213.87 19.7168 212.88 20.6886 212.002 20.1804L211.23 19.7337C210.921 19.5544 210.539 19.5544 210.229 19.7337L209.457 20.1804Z"
        fill="var(--color-illustration-element)"
      />
      <circle
        cx="61.5551"
        cy="60.8812"
        r="8.38124"
        fill="var(--color-illustration-element)"
      />
      <line
        x1="177.498"
        y1="57.715"
        x2="78.1204"
        y2="57.715"
        stroke="var(--color-illustration-element)"
        strokeWidth="4.78928"
        strokeLinecap="round"
      />
      <line
        x1="137.986"
        y1="67.2935"
        x2="78.1202"
        y2="67.2935"
        stroke="var(--color-illustration-element)"
        strokeWidth="4.78928"
        strokeLinecap="round"
      />
      <line
        x1="177.498"
        y1="76.8721"
        x2="78.1204"
        y2="76.8721"
        stroke="var(--color-illustration-element)"
        strokeWidth="4.78928"
        strokeLinecap="round"
      />
      <defs>
        <clipPath id="clip0_939_25445">
          <rect
            x="42.2002"
            y="42.4102"
            width="151.248"
            height="191.138"
            rx="7.18392"
            fill="var(--color-illustration-card)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
